import { IsMongoId } from 'class-validator';

import { SubmitDraftDto } from './submit-draft.dto';

/**
 * A single item in a bulk-submit request. Contains the draft id plus the
 * same mutable fields as a regular single-draft submit.
 */
export class SubmitDraftItemDto extends SubmitDraftDto {
  @IsMongoId()
  public id: string;
}
